import urbanLogo from "../../assets/images/urban/urban-logo-01.png";
import { RiMenu2Fill } from "react-icons/ri";
import Container from "./container";
import { navlinksData } from "./mock";
import NavLink from "./nav-link";
import NavSubLink from "./nav-sub-link";
import { MdClose } from "react-icons/md";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    if (navOpen) {
      document.body.style.overflow = "hidden";
      return;
    }
    if (!navOpen) {
      document.body.style.overflow = "auto";
      return;
    }
  }, [navOpen]);

  const closeNav = () => setNavOpen(false);

  console.log("navOpne", navOpen);
  return (
    <header className="bg-[#e7e5e5] relative z-50">
      <Container className=" md:pt-4 pt-2 pb-1  flex items-center gap-8 justify-between md:justify-start">
        <div className="lg:w-[160px] w-[120px]">
          <Link to={"/"}>
            <img src={urbanLogo} alt="Urban Logo" />
          </Link>
        </div>
        <nav
          className={`text-white md:text-black  md:block md:bg-transparent bg-[#e60000] absolute [right:-110%] top-0 md:right-auto  justify-center md:relative  ${
            navOpen && "!right-0"
          } transition-all duration-300`}
        >
          <ul className="flex items-center   justify-center flex-col md:flex-row gap-12 text-xl w-screen md:w-auto md:h-auto h-screen">
            <div className="md:hidden block absolute right-5 top-10 border p-2 rounded-full cursor-pointer">
              <MdClose size={30} onClick={closeNav} />
            </div>
            {navlinksData.map((link, idx) => {
              if (link.sublinks) {
                return (
                  <NavSubLink key={link?.label} {...link} clickFn={closeNav} />
                );
              }
              return <NavLink key={link?.label} {...link} clickFn={closeNav} />;
            })}
          </ul>
        </nav>
        <button
          className="hamburgur md:hidden"
          onClick={() => setNavOpen(true)}
        >
          <RiMenu2Fill size={30} />
        </button>
      </Container>
    </header>
  );
};

export default Navbar;
